// DISPLAY date formats - identical in every language.
//
// Decision (2026-08-12): the date format is unified to DD.MM.YYYY in both Polish and English.
// This SUPERSEDES rule 2 of rules.png ("Formaty dat lokalne"), which originally called for a
// per-language format. Day and month NAMES are still translated - only the numeric pattern is
// shared - so the English UI shows "Monday", "August" and "(Mo)" next to a dot-separated date.
//
// These are deliberately scalars rather than per-language maps: a constant with no language
// branch cannot drift apart again.
//
// The wire format is a separate concern and is NOT defined here - it stays
// config.get("dateFormat") === "YYYY-MM-DD", an API contract rather than a display preference.
//
// This module has no imports on purpose: both src/i18n/dates.js and src/i18n/prime/index.js
// consume it, and keeping it a leaf avoids a circular import between them.

// moment tokens
export const DISPLAY_DATE_FORMAT = "DD.MM.YYYY";

// PrimeReact Calendar tokens (D = short day name, taken from the active locale bundle)
export const PRIME_DATE_FORMAT = "dd.mm.yy";
export const PRIME_DATE_FORMAT_WITH_DAY = "dd.mm.yy (D)";

// react-datepicker uses date-fns tokens, which differ again from moment's.
export const DATEPICKER_DATE_FORMAT = "dd.MM.yyyy";
